import {
  FilterType,
  buildCustomTemplatesDataTableFilter,
  useCustomTemplatesDataTable,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

import AccessFilterSelector from 'modules/performance_process/components/reviews/ReviewsDataTable/filters/AccessFilterSelector'

const authorFilter = (source: ReturnType<typeof useCustomTemplatesDataTable>) =>
  buildCustomTemplatesDataTableFilter(source, {
    title: i18n.t('common.author'),
    path: 'authorId',
    type: FilterType.Entity,
    categories: [
      {
        kind: 'Entity',
        operation: 'in',
        nameAttribute: 'fullName',
        component: () => {
          return <AccessFilterSelector />
        },
      },
    ],
    identifier: 'author',
  })

export default authorFilter
